"use client";

import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Import images
import img1 from "../../../assets/banner1.png";
import img2 from "../../../assets/banner2.png";
import img3 from "../../../assets/banner3.png";
import img4 from "../../../assets/banner4.png";

const sliderImages = [
  { id: 1, src: img1, title: "Organic Chemistry" },
  { id: 2, src: img2, title: "Inorganic Chemistry" },
  { id: 3, src: img3, title: "Physical Chemistry" },
  { id: 4, src: img4, title: "Analytical Chemistry" },
];

export default function ImageSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  useEffect(() => {
    if (!autoPlay) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [autoPlay]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
    setAutoPlay(false);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + sliderImages.length) % sliderImages.length
    );
    setAutoPlay(false);
  };

  return (
    <div className="relative w-96 md:w-[500px] h-[480px] md:h-[640px] rounded-2xl overflow-hidden shadow-lg">
      {/* Slides */}
      <div className="relative w-full h-full">
        {sliderImages.map((image, index) => (
          <div
            key={image.id}
            className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
              index === currentSlide ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={image.src}
              alt={image.title}
              className="w-full h-full object-cover"
            />
            {/* <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center text-center text-white">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-lg">
                {image.title}
              </h2>
            </div> */}
          </div>
        ))}
      </div>

      {/* Navigation Buttons */}
      <button
        onClick={prevSlide}
        onMouseEnter={() => setAutoPlay(false)}
        onMouseLeave={() => setAutoPlay(true)}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-10 bg-black/30 hover:bg-black/50 text-white p-2 rounded-full transition"
      >
        <ChevronLeft size={28} />
      </button>

      <button
        onClick={nextSlide}
        onMouseEnter={() => setAutoPlay(false)}
        onMouseLeave={() => setAutoPlay(true)}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-black/30 hover:bg-black/50 text-white p-2 rounded-full transition"
      >
        <ChevronRight size={28} />
      </button>

      {/* Dots / Indicators */}
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {sliderImages.map((_, index) => (
          <button
            key={index}
            onClick={() => {
              setCurrentSlide(index);
              setAutoPlay(false);
            }}
            className={`rounded-full transition-all duration-300 ${
              index === currentSlide
                ? "w-4 h-4 bg-white"
                : "w-2 h-2 bg-white/60 hover:bg-white/90"
            }`}
          />
        ))}
      </div>
    </div>
  );
}
